<template lang="pug">
panel-base(
  :title="title"
  :value="inputValue"
  :action-type="actionType"
  v-bind="$attrs"
  v-on="actionEvents"
)
  component(
    :is="inputComponent"
    v-model="textInput"
    v-bind="textInputAttrs"
    v-on="textInputListeners"
  ).mt-2
  //- app-button(
  //-   rounded
  //-   :disabled="isIndicateButtonDisabled"
  //-   @click="indicateTextInput"
  //- ).mt-2 Указать
</template>

<script>
import PanelBase from './PanelBase.vue';
import AppTextInput from '@/components/user-redesign/inputs/AppTextInput.vue';
import SnilsInput from '@/components/user-redesign/inputs/SnilsInput.vue';
import PhoneInput from '@/components/user-redesign/inputs/PhoneInput.vue';
import InnInput from '@/components/user-redesign/inputs/InnInput.vue';
import { PANEL_TEXT_INPUT_COMPONENT_KEY, ROW_ACTION_KEY } from '../constants';

const PANEL_TEXT_INPUT_COMPONENT_MAP = {
  [PANEL_TEXT_INPUT_COMPONENT_KEY.textInput]: AppTextInput,
  [PANEL_TEXT_INPUT_COMPONENT_KEY.snils]: SnilsInput,
  [PANEL_TEXT_INPUT_COMPONENT_KEY.phone]: PhoneInput,
  [PANEL_TEXT_INPUT_COMPONENT_KEY.inn]: InnInput,
};

export default {
  name: 'PanelTextInput',
  components: {
    PanelBase,
    SnilsInput,
    PhoneInput,
    InnInput,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    /**
     *  'text-input' | 'snils-input' | 'phone-input' | 'inn-input'
     */
    component: {
      type: String,
      default: PANEL_TEXT_INPUT_COMPONENT_KEY.textInput,
      validator(value) {
        return Object.values(PANEL_TEXT_INPUT_COMPONENT_KEY).includes(value);
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      textInput: this.value,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inputComponent() {
      return PANEL_TEXT_INPUT_COMPONENT_MAP[this.component];
    },
    textInputAttrs() {
      const { value, ...rest } = this.$attrs;

      return {
        ...rest,
        label: this.title,
      };
    },
    textInputListeners() {
      const { input, ...rest } = this.$listeners;

      return {
        ...rest,
      };
    },
    actionType() {
      const { indicate } = ROW_ACTION_KEY;

      return indicate;
    },
    actionEvents() {
      const { reset } = ROW_ACTION_KEY;

      return {
        [`click:${reset}`]: () => {
          this.inputValue = null;
          this.textInput = '';
        },
      };
    },
    isIndicateButtonDisabled() {
      return !this.textInput || this.inputValue === this.textInput;
    },
  },
  watch: {
    textInput() {
      if (!this.isIndicateButtonDisabled) this.indicateTextInput();
    },
  },
  created() {},
  methods: {
    indicateTextInput() {
      this.inputValue = this.textInput;
      // this.$emit('click:select');
    },
  },
};
</script>
